import { useEffect, useState } from 'react'

export type DelighterTextsReturnType = {
  text: string
  progressCount: number
}

export function useDelighterTexts(args: {
  texts: string | Array<string>
}): DelighterTextsReturnType {
  const { texts } = args
  const PROCESSING_SECONDS = 15
  const shouldUseProgressTexts = Array.isArray(texts)
  const [progressCount, setProgressCount] = useState(0)
  const [buttonLabelText, setButtonLabelText] = useState('')

  useEffect(() => {
    if (shouldUseProgressTexts) {
      if (progressCount === 0) {
        setButtonLabelText(texts[0])
      }
      const timeInterval = Math.floor(PROCESSING_SECONDS / texts.length) * 1000
      const interval = setInterval(() => {
        const label =
          progressCount < texts.length - 1
            ? texts[progressCount + 1]
            : texts[texts.length - 1]
        setButtonLabelText(label)
        setProgressCount((prev) => prev + 1)
      }, timeInterval)

      return () => {
        clearInterval(interval)
      }
    } else {
      setButtonLabelText(texts)
    }
  }, [shouldUseProgressTexts, texts, progressCount])

  return {
    text: buttonLabelText,
    progressCount,
  }
}
